import styled from 'styled-components'
import { mq } from 'styles/mq'
import { theme } from 'styles/theme'

export const Title = styled.h1`
  margin: 8rem 0 0;
  font: 600 5rem ${theme.fonts.headings};
  text-transform: uppercase;
`

export const Hr = styled.hr`
  margin: 5rem 0;
  border: none;
  border-top: 1px solid #565555;
`

export const Subtitle = styled.h2`
  margin: 3rem 0 2rem;
  font-weight: 400;
  text-transform: uppercase;
  font-size: 3rem;

  ${mq.medium} {
    font-size: 4.5rem;
  }
`

export const List = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  font-size: 2.4rem;

  li {
    margin: 0.4em 0;
  }
`
